import { useQuery } from "@tanstack/react-query"
import { queryClient as qc } from 'keys'
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { actions } from "store"
import { getAudioFileFetch } from "store/middlewares/assessment.crud"
import { markingWordsHooks } from "pages/Admin/TranscriptionSystem/MarkingWords"

const useGetAudioFile = () => {
    const dispatch = useDispatch()

    const { assessment } = useSelector(state => state.assessment)

    const isTraining = markingWordsHooks.useIsTraining()

    return useQuery({
        queryKey: [qc.getAudioFile, assessment.id],
        queryFn: async ({ signal }) => {
            if (!assessment?.audio_file) {
                const { data } = await getAudioFileFetch({ assessmentID: assessment.id, signal }, isTraining)
                if (data) {
                    const audioURL = URL.createObjectURL(new Blob([data]));
                    dispatch(actions.updateAssessment({ audio_file: audioURL }))
                }
            }
        },
        refetchOnWindowFocus: false,
        enabled: !!assessment?.audio_file_url,
        refetchIntervalInBackground: false,
        retry: 0
    })
}

export default useGetAudioFile
